/* Rippl site footer (home study v96). Source: theme-build/assets/rf-footer.js
   The water film loads as the page nears its end, plays while it is in view at 0.75 speed and rests when it is not.
   v96: the film is drawn through the home hero's WebGL navy grade (assets/rippl-water.js) with the hero's low
   pointer ripples, fading itself in from the white above. WebGL starts only when the footer nears the screen and
   draws only while it is on screen. With reduced motion the still stays and nothing plays; with reduced
   transparency, no WebGL or the Water setting off, the film shows under its navy veil (v82).
   Pre-publish sweep (14 Oct 2026, fix A5): the still (an <img loading=lazy>, not a CSS background) is the first paint;
   the film is fetched only when the footer is within one screen AND the page has loaded (or the visitor has
   scrolled, or 6 s have passed), so on a short page (Cart) it never competes with the first screen. With the WebGL
   water running, the <video> element itself is never shown (the canvas draws it), so the still stays the footer's
   largest paint and the film cannot become a late LCP.
   Footer-join phone fix (18 Oct 2026, approved by Bade): on phones (under 820px) the WebGL water never starts. The
   film plays at full size over its still as one steady layer, with no swap as the footer arrives (rf-footer.css
   paints the white fade on phones instead of a mask). The home hero's water (rhm-hero.js) is unchanged. */
(function () {
  'use strict';
  var W = window;
  var reduce = W.matchMedia('(prefers-reduced-motion: reduce)');
  var lessGlass = W.matchMedia('(prefers-reduced-transparency: reduce)');
  function init(ft) {
    if (!ft || ft.__rf) return;
    ft.__rf = true;
    var v = ft.querySelector('.rf-v');
    if (!v) return;
    var rate = parseFloat(v.dataset.rate) || 0.75, set = null, near = false, inView = false, gate = false, started = false;
    function play() {
      if (reduce.matches || !near || !inView || !v.getAttribute('src')) return;
      v.defaultPlaybackRate = rate; v.playbackRate = rate;
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    }
    function pick() {
      if (!started) return;
      var w = window.innerWidth >= 820 ? 'w' : 'p';
      if (w === set) return;
      set = w;
      var src = v.dataset[w] || v.dataset[w === 'w' ? 'p' : 'w'] || '';
      var poster = v.dataset[w + 'p'] || '';
      if (poster) v.poster = poster;
      if (started && src && !reduce.matches) { v.src = src; play(); }
    }
    /* the film itself shows only when the WebGL water is not drawing it (fallback v82) */
    v.addEventListener('playing', function () { if (!water) v.classList.add('on'); });
    function start() {
      if (started || !near || !gate) return;
      started = true; set = null; startWater(); pick();
    }
    function openGate() { if (gate) return; gate = true; start(); }
    if (document.readyState === 'complete') gate = true;
    else {
      window.addEventListener('load', openGate, { once: true });
      window.addEventListener('scroll', openGate, { once: true, passive: true });
      setTimeout(openGate, 6000);
    }

    /* ---- the hero's water ---- */
    var water = null; /* null: not tried yet, false: not available, else the running state */
    function num(k, d) { var x = parseFloat(ft.dataset[k]); return isFinite(x) ? x : d; }
    function startWater() {
      if (water !== null) return;
      water = false;
      if (reduce.matches || lessGlass.matches || ft.dataset.water === '0' || !W.RipplWater) return;
      if (W.matchMedia('(max-width: 819px)').matches) return; /* phones: the plain film, no WebGL swap */
      var c = document.createElement('canvas');
      c.className = 'rf-gl'; c.setAttribute('aria-hidden', 'true');
      var w = W.RipplWater.create(c);
      if (!w) return;
      var gl = w.gl, U = w.U, G = W.RipplWater.GRADE, rs = Math.max(0, num('ripple', 1));
      gl.uniform1f(U.G, G.G); gl.uniform1f(U.F, G.F); gl.uniform1f(U.K, G.K);
      gl.uniform1f(U.BS, num('base', G.BS)); gl.uniform1f(U.HS, num('high', G.HS));
      gl.uniform3f(U.FL, .0118, .0431, .1098);  /* never lighter than the study's deepest navy */
      gl.uniform1f(U.A, 1);                    /* fade in from the white at the top */
      var bg = ft.querySelector('.rf-bg');
      ft.insertBefore(c, bg ? bg.nextSibling : ft.firstChild);
      /* the canvas draws the film: the <video> itself shrinks to 1px so it can never count as the page's largest paint */
      ft.classList.add('rf-glon');
      var drops = new Float32Array(64), di = 0, t0 = performance.now(), raf = 0, ready = false, lost = false, dirty = true, lastDrop = -1e9;
      /* upload the film only when it has a new frame, and draw only when the film or a ripple has changed
         (Apple audit round 2, C5: 60 uploads and draws a second down to about 18 when the pointer is still) */
      var fresh = W.RipplWater.watch ? W.RipplWater.watch(v) : { fresh: function () { return true; }, poke: function () {} };
      function now() { return (performance.now() - t0) / 1000; }
      function drop(x, y, k) { if (rs > 0) { drops.set([x, y, now(), k * rs], di * 4); di = (di + 1) % 16; lastDrop = performance.now(); if (water) water.wake(); } }
      function size() {
        var cw = ft.clientWidth, ch = ft.clientHeight; if (!cw || !ch || lost) return;
        /* at most 2x, and at most about 3.2 million pixels: the film is softer than that anyway */
        var d = Math.min(W.devicePixelRatio || 1, 2, Math.sqrt(3.2e6 / (cw * ch)));
        c.width = Math.round(cw * d); c.height = Math.round(ch * d);
        gl.viewport(0, 0, c.width, c.height); gl.uniform2f(U.R, c.width, c.height);
        /* cover crop of the raw video frame */
        var ca = cw / ch, va = (v.videoWidth && v.videoHeight) ? v.videoWidth / v.videoHeight : (W.innerWidth >= 820 ? 16 / 9 : 9 / 16);
        var sx = ca > va ? 1 : ca / va, sy = ca > va ? va / ca : 1;
        gl.uniform4f(U.SO, sx, sy, .5 - .5 * sx, .5 - .5 * sy);
        dirty = true;
      }
      function frame() {
        raf = 0;
        if (lost || !inView || !ft.isConnected) return;
        if (v.readyState >= 2) {
          var nf = fresh.fresh() || !ready;
          if (nf) {
            gl.bindTexture(gl.TEXTURE_2D, w.tex);
            try { gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGB, gl.RGB, gl.UNSIGNED_BYTE, v); } catch (e) { return die(); }
            if (!ready) { ready = true; size(); ft.classList.add('rf-wgl'); }
          }
          /* a drop lives 2.6 s; the water itself only changes when the film does */
          if (nf || dirty || performance.now() - lastDrop < 2700) {
            dirty = false;
            gl.uniform1f(U.t, now()); gl.uniform4fv(U.D, drops); gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
          }
        }
        raf = requestAnimationFrame(frame);
      }
      function die() { lost = true; ft.classList.remove('rf-wgl', 'rf-glon'); v.classList.add('on'); if (raf) cancelAnimationFrame(raf); raf = 0; }
      c.addEventListener('webglcontextlost', function (e) { e.preventDefault(); die(); });
      size();
      if ('ResizeObserver' in W) new ResizeObserver(size).observe(ft); else W.addEventListener('resize', size);
      v.addEventListener('loadedmetadata', size);
      function at(e) { var r = ft.getBoundingClientRect(); return [(e.clientX - r.left) / r.width, (e.clientY - r.top) / r.height]; }
      var lastMove = 0;
      ft.addEventListener('pointermove', function (e) { var t = performance.now(); if (t - lastMove < 110) return; lastMove = t; var q = at(e); drop(q[0], q[1], .3); });
      ft.addEventListener('pointerdown', function (e) { if (e.target.closest && e.target.closest('a')) return; var q = at(e); drop(q[0], q[1], 1); });
      water = { wake: function () { if (!raf && !lost && inView) raf = requestAnimationFrame(frame); } };
      water.wake();
    }

    window.addEventListener('resize', pick);
    if (!('IntersectionObserver' in window)) { ft.classList.add('in'); near = true; inView = true; gate = true; start(); return; }
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting && !near) { near = true; start(); } });
    }, { rootMargin: '100% 0px' }).observe(ft);
    new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        inView = e.isIntersecting;
        if (e.isIntersecting) { if (e.intersectionRatio > 0.3 || e.boundingClientRect.top < window.innerHeight * 0.7) ft.classList.add('in'); play(); if (water) water.wake(); }
        else if (!v.paused) v.pause();
      });
    }, { threshold: [0, 0.3] }).observe(ft);
  }
  function boot() { [].slice.call(document.querySelectorAll('[data-rf]')).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
